import React from 'react';
import { ProductStoreHeader } from './product-store-header';
import { useViewStateContext } from '../context';
import { DrawerCloseButton } from '@atlaskit/drawer/compiled';
import { Box, media, xcss } from '@atlaskit/primitives';
import CrossIcon from '@atlaskit/icon/core/migration/close--cross';

const boxStyle = xcss({
	position: 'absolute',
	top: 'space.050',
	[media.above.xs]: {
		top: 'space.150',
		left: 'space.150',
	},
});

export const BaseHeader = () => {
	return (
		<Box xcss={boxStyle}>
			<DrawerCloseButton icon={CrossIcon} testId="drawer-close-button" />
		</Box>
	);
};

export const CrossFlowSupportHeader = () => {
	const { state } = useViewStateContext();
	if (state.sourceContext === 'more' && state.targetProduct !== 'loom') {
		return <ProductStoreHeader />;
	}
	return <BaseHeader />;
};
